import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ConsentSvgIconComponent } from './consent-svg-icon/consent-svg-icon.component'
import { EmailSvgIconComponent } from './email-svg-icon/email-svg-icon.component'
import { ErrorSvgIconComponent } from './error-svg-icon/error-svg-icon.component'
import { InfoSvgIconComponent } from './info-svg-icon/info-svg-icon.component'
import { PasswordSvgIconComponent } from './password-svg-icon/password-svg-icon.component'
import { PhoneSvgIconComponent } from './phone-svg-icon/phone-svg-icon.component'
import { UserSvgIconComponent } from './user-svg-icon/user-svg-icon.component'
import { FeedbackFailureSvgIconComponent } from './feedback-failure-svg-icon/feedback-failure-svg-icon.component'
import { UnconfirmedAccountSvgIconComponent } from './unconfirmed-account-svg-icon/unconfirmed-account-svg-icon.component'
import { ConfirmEmailSvgIconComponent } from './confirm-email-svg-icon/confirm-email-svg-icon.component'

@NgModule({
  declarations: [
    UserSvgIconComponent,
    PhoneSvgIconComponent,
    ConsentSvgIconComponent,
    EmailSvgIconComponent,
    PasswordSvgIconComponent,
    InfoSvgIconComponent,
    ErrorSvgIconComponent,
    FeedbackFailureSvgIconComponent,
    UnconfirmedAccountSvgIconComponent,
    ConfirmEmailSvgIconComponent,
  ],
  exports: [
    UserSvgIconComponent,
    PhoneSvgIconComponent,
    ConsentSvgIconComponent,
    EmailSvgIconComponent,
    PasswordSvgIconComponent,
    InfoSvgIconComponent,
    ErrorSvgIconComponent,
    FeedbackFailureSvgIconComponent,
    UnconfirmedAccountSvgIconComponent,
    ConfirmEmailSvgIconComponent,
  ],
  imports: [CommonModule],
})
export class SvgIconsModule {}
